import { RouterActionTypes } from '../actions/router.action.types';
var defaultstate = [];
var HistoryReducerFactory = /** @class */ (function () {
    function HistoryReducerFactory(windowObj) {
        if (windowObj !== undefined && windowObj !== null)
            this._window = windowObj;
        else
            this._window = window;
    }
    HistoryReducerFactory.prototype.Create = function () {
        var _this = this;
        var HistoryReducer = function (state, action) {
            if (state === void 0) { state = defaultstate; }
            switch (action.type) {
                case RouterActionTypes.SYNC_ROUTE:
                    return appendHistory(state);
                case RouterActionTypes.GO_BACK:
                    return deleteHistory(state);
            }
            return state;
        };
        var appendHistory = function (state) {
            if (!_this._window || !_this._window.location)
                return state;
            var currentLocationHash = _this._window.location.hash;
            if (currentLocationHash === undefined || currentLocationHash === null)
                return state;
            var currentUrl = currentLocationHash.substring(1);
            return [currentUrl].concat(state);
        };
        var deleteHistory = function (state) {
            if (state === undefined || state === null || state.length <= 1)
                return [];
            return state.slice(state.length - 1).slice();
        };
        return HistoryReducer;
    };
    return HistoryReducerFactory;
}());
export { HistoryReducerFactory };
export var HistoryReducer = new HistoryReducerFactory().Create();
//# sourceMappingURL=history.reducer.js.map